let sessionExpiryHandler;

export function setSessionExpiryHandler(handler) {
  sessionExpiryHandler = typeof handler === 'function' ? handler : undefined;
}

export function isSessionExpiredError(error) {
  return !!(error && error.sessionExpired === true);
}

export function createSessionExpiredError(message) {
  const error = new Error(
    typeof message === 'string' && /[\u3400-\u9fff]/.test(message)
      ? message
      : '登录会话已失效，请重新登录',
  );
  error.sessionExpired = true;
  error.status = 401;
  return error;
}

export function notifySessionExpired(payload) {
  if (!sessionExpiryHandler) return;
  try {
    const pending = sessionExpiryHandler(payload);
    if (pending && typeof pending.catch === 'function') pending.catch(() => {});
  } catch {
    // A navigation failure must not replace the handled authentication error.
  }
}
